import { render, staticRenderFns } from "./MyDownloads.vue?vue&type=template&id=ee7f7628&scoped=true&"
import script from "./MyDownloads.vue?vue&type=script&lang=js&"
export * from "./MyDownloads.vue?vue&type=script&lang=js&"
import style0 from "./MyDownloads.vue?vue&type=style&index=0&id=ee7f7628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7f7628",
  null
  
)

export default component.exports